export const arrivalsDeparturesDaysExtract = (arrivalsDeparturesDays: string) => {
  const checkInDates: string[] = [];
  const checkOutDates: string[] = [];

  for (let i = 0; i < arrivalsDeparturesDays?.length; i++) {
    if (i < 7) {
      if (arrivalsDeparturesDays[i] !== '_') {
        checkInDates.push(arrivalsDeparturesDays[i]);
      }
    } else {
      if (arrivalsDeparturesDays[i] !== '_') {
        checkOutDates.push(arrivalsDeparturesDays[i]);
      }
    }
  }

  return { checkInDates, checkOutDates };
};
